var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.116 4.503a1.5 1.5 0 1 0-2.242 1.993l1.78 2.003H8.496a1.5 1.5 0 0 0 0 3h6.158l-1.78 2.003a1.501 1.501 0 0 0 2.242 1.993L20 9.998l-4.884-5.497Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.498 5a1.5 1.5 0 0 0 0-3H1.499A1.5 1.5 0 0 0 0 3.5v13A1.5 1.5 0 0 0 1.499 18h3.999a1.5 1.5 0 0 0 0-3H2.999V5h2.499Z"
  })));
};
export default SvgExport;